import React, { useState } from 'react'
import { Button, Form, Input, Typography } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../../../util/IntlMessages'

const { Paragraph } = Typography

export interface IAdpStepProps {
  email: string
  isBusy: boolean
  onSubmit: (email: string) => void
  onEmailChanged: (email: string) => void
}

const AdpStep = ({ email, isBusy, onSubmit, onEmailChanged }: IAdpStepProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const [hasTyped, setHasTyped] = useState(false)

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <Paragraph className="connect-with-email" style={{ marginBottom: 8, fontWeight: 600 }}>
          <IntlMessages id="signin.adpStep1" />
        </Paragraph>
        <Paragraph type="secondary" style={{ fontSize: 12, marginBottom: 0 }}>
          <IntlMessages id="signin.adpStep1Description" />
        </Paragraph>
      </div>
      <Form
        name="connect-with-email"
        form={form}
        layout="horizontal"
        initialValues={{ email }}
        onFinish={(values) => onSubmit(values.email)}
        onFieldsChange={() => onEmailChanged(form.getFieldValue('email') ?? '')}
      >
        <Form.Item
          name="email"
          style={{ width: '100%' }}
          // Half a typed address is not a wrong one, and an untouched field is not one either:
          // this screen can open empty, so leaving the field must not scold a visitor who
          // never typed a character.
          validateTrigger={hasTyped ? 'onBlur' : []}
          rules={[{ required: true, type: 'email', message: <IntlMessages id="connect.pleaseInputValidEmail" /> }]}
        >
          <Input
            className="email-input data-hj-allow"
            size="large"
            data-qa="email-login-mail"
            placeholder={formatMessage({ id: 'app.enterWorkEmailForADP' })}
            onChange={() => setHasTyped(true)}
          />
        </Form.Item>
        <div style={{ marginTop: 24, marginBottom: 12 }}>
          <Paragraph style={{ marginBottom: 4, fontWeight: 600, fontSize: 14 }}>
            <IntlMessages id="signin.adpStep2" />
          </Paragraph>
          <Paragraph type="secondary" style={{ fontSize: 12, marginBottom: 0 }}>
            <IntlMessages id="signin.adpStep2Description" />
          </Paragraph>
        </div>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" disabled={isBusy} loading={isBusy} data-qa="signin-adp-submit" block>
            <IntlMessages id="createCompany.connectWithADP" />
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}

export default AdpStep
